import React from 'react';
import { LinearProgress } from '@material-ui/core';

export default function ProgressBar(props) {

    const { value } = props;

    return (
      <LinearProgress variant="determinate" value={value} color="primary" />
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/ProgressBar/ProgressBar.js